import { API } from 'aws-amplify';
import { TUTORING_V2_URL_APPEND } from 'constants';

export const getTutoringV2Availability = async (
  studentId,
  subjectId,
  date,
  overrideLimits,
) => {
  const queryStringParameters = {
    studentId: studentId,
    subjectId: subjectId,
    date: date,
    overrideLimits: overrideLimits,
  };
  const availabileTimes = await API.get(
    'delta-api',
    `${TUTORING_V2_URL_APPEND}/availability?`,
    {
      headers: {},
      queryStringParameters: queryStringParameters,
    },
  );
  return availabileTimes;
};

export const getTutoringV2BookedSessions = async (
  pageSize,
  paginationKey,
  earliestDate,
  latestDate,
  studentId,
  subjectId,
  ascending,
  includeCancelled,
) => {
  const queryStringParameters = {
    limit: pageSize,
    paginationKey: paginationKey,
  };
  if (earliestDate) {
    queryStringParameters.earliestDate = earliestDate;
  }
  if (latestDate) {
    queryStringParameters.latestDate = latestDate;
  }
  if (studentId) {
    queryStringParameters.studentId = studentId;
  }
  if (subjectId) {
    queryStringParameters.subjectId = subjectId;
  }
  if (ascending) {
    queryStringParameters.ascending = ascending;
  }
  if (includeCancelled) {
    queryStringParameters.includeCancelled = includeCancelled;
  }

  const bookedSessions = await API.get(
    'delta-api',
    `${TUTORING_V2_URL_APPEND}/sessions?`,
    {
      headers: {},
      queryStringParameters: queryStringParameters,
    },
  );

  return bookedSessions;
};

export const postTutoringV2Session = async (payload) => {
  const myPayload = {
    body: payload,
  };

  await API.post('delta-api', `${TUTORING_V2_URL_APPEND}/sessions`, myPayload);
};

export const putCancelTutoringV2Session = async (payload, sessionId) => {
  const myPayload = {
    body: payload,
  };

  await API.put(
    'delta-api',
    `${TUTORING_V2_URL_APPEND}/sessions/${sessionId}/cancel`,
    myPayload,
  );
};
